import { render, staticRenderFns } from "./MidChart2.vue?vue&type=template&id=15c37452&scoped=true&"
import script from "./MidChart2.vue?vue&type=script&lang=js&"
export * from "./MidChart2.vue?vue&type=script&lang=js&"
import style0 from "./MidChart2.vue?vue&type=style&index=0&id=15c37452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c37452",
  null
  
)

export default component.exports